import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchServiceRequest, updateServiceRequest } from "../../redux/action"
import './WaiterRequest.css';
import EmptyScreen from "../../component/common/EmptyScreen";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";
import WaiterRequestMobile from "./WaiterRequestMobile.js";

const WaiterRequestPage = () => {

    const dispatch = useDispatch();
    const realtimeRevision = useSelector(state => state.notifications?.requestsRevision || 0);
    const request = useSelector((state) => state.admin.get);
    const [servedRequests, setServedRequests] = useState([]);
    const [cancelRequests, setCancelRequests] = useState([]);
    const [pendingRequests, setPendingRequests] = useState([]);
    const isMobile = useIsMobile();


    useEffect(() => {
        dispatch(fetchServiceRequest());
    }, [dispatch, realtimeRevision]);

    useEffect(() => {
        if (Array.isArray(request)) {
            setPendingRequests(request.filter(s => s.statusId === 0));
            setServedRequests(request.filter(s => s.statusId === 1));
            setCancelRequests(request.filter(s => s.statusId === 2));
        }
    }, [request]);




    const handleServe = (requestId) => {
        const dto = { requestId: requestId, statusId: 1 }
        dispatch(updateServiceRequest(dto))
    };

    const handleCancel = (requestId) => {
        const dto = { requestId: requestId, statusId: 2 }
        dispatch(updateServiceRequest(dto))
    };

    const [selectedTab, setSelectedTab] = useState('Pending');
    const displayTab = (tab) => {
        setSelectedTab(tab)
    }
    return (
        <div> {/* Tabs */}

            <div className='notification-tabs'>
                <button class={selectedTab === 'Pending' ? 'active' : 'tab'} onClick={() => displayTab("Pending")}>Pending</button>
                <button class={selectedTab === 'Served' ? 'active' : 'tab'} onClick={() => displayTab("Served")}>Served</button>
                <button class={selectedTab === 'Cancelled' ? 'active' : 'tab'} onClick={() => displayTab("Cancelled")}>Cancelled</button>
            </div>
            {/* Pending Table */}
            <div className={selectedTab === 'Pending' ? 'show' : 'hide'} >
                <div className="request-title">
                    {/* <h3 style={{ margin: 0 }}>Pending Requests</h3> */}
                    {/* <button onClick={() => cleanAll("Pending")} className="clear-btn">Clean All</button> */}
                </div>


                {pendingRequests.length === 0 ? (
                    <EmptyScreen message="No waiter request(s) found." />
                ) : (
                    <>
                    {isMobile ? (<WaiterRequestMobile requestType={pendingRequests} status={'Pending'} />):
                    
                    ( <table className="requests-table">
                        <thead>
                            <tr> <th>Table No.</th>
                                <th>Request Type</th>
                                <th>Time</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendingRequests.map((req) => (<tr key={req.requestId} className="status-pending">
                                <td>
                                    T-{req.restaurantTable?.tableName}
                                </td>
                                <td>{req.notes}</td>
                                <td>{req.requestTime}</td>
                                <td>Pending</td>
                                <td>
                                    <button className="serve-btn" onClick={() => handleServe(req.requestId)}>Serve</button>
                                    <button className="cancel-btn" onClick={() => handleCancel(req.requestId)}>Cancel</button>
                                </td>
                            </tr>))}
                        </tbody>

                    </table>)}
                    </>
                )}
            </div>
            {/* Served Table */}
            <div className={selectedTab === 'Served' ? 'show' : 'hide'}>
                <div className="request-title">
                    {/* <h3 style={{ margin: 0 }}>Served Requests</h3> */}
                    {/* <button onClick={() => cleanAll("Served")} className="clear-btn">Clean All</button> */}
                </div>

                {servedRequests.length === 0 ? (
                    <EmptyScreen message="No waiter request(s) found." />
                ) : (

                    <>
                    {isMobile ? (<WaiterRequestMobile requestType={servedRequests} status={'Served'} />):
                    ( <table className="requests-table">
                        <thead>
                            <tr>
                                <th>Table No.</th>
                                <th>Request Type</th>
                                <th>Time</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody> {servedRequests.map((req) => (<tr key={req.requestId} className="status-served">
                            <td>
                                T-{req.restaurantTable?.tableName}
                            </td>
                            <td>{req.notes}</td>
                            <td>{req.requestTime}</td>
                            <td>Served</td>
                        </tr>))}
                        </tbody>
                    </table> )}
                    </>
                )}
            </div>
            {/* Cancel Table */}
            <div className={selectedTab === 'Cancelled' ? 'show' : 'hide'} >
                <div className="request-title">
                    {/* <h3 style={{ margin: 0 }}>Cancel Requests</h3> */}
                    {/* <button onClick={() => cleanAll("Cancel")} className="clear-btn">Clean All</button> */}
                </div>

                {cancelRequests.length === 0 ? (
                    <EmptyScreen message="No waiter cancelled request(s) found." />
                ) : (
                     <>
                     {isMobile ? (<WaiterRequestMobile requestType={cancelRequests} status={'Cancelled'} />):
                     (
                        <table className="requests-table">
                        <thead>
                            <tr>
                                <th>Table No.</th>
                                <th>Request Type</th>
                                <th>Time</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody> {cancelRequests.map((req) => (<tr key={req.requestId} className="status-delayed">
                            <td>
                                T-{req.restaurantTable?.tableName}
                            </td>
                            <td>{req.notes}</td>
                            <td>{req.requestTime}</td>
                            <td>Cancelled</td>
                        </tr>))}
                        </tbody>
                    </table>
                     )}
                     </>
                )}
            </div>

        </div>);
};


export default WaiterRequestPage;
